import i18n from '@plugins/i18n';

export default [
    {
        path: '/offers',
        name: 'Offers',
        component: () => import('@/views/Offers.vue'),
        redirect: {
            name: 'OffersAll'
        },
        meta: {
            title: i18n.t('investment_offers'),
            heading: i18n.t('investment_offers'),
            description: i18n.t('see_list_of_all_offers_available')
        },
        children: [
            {
                path: 'all',
                name: 'OffersAll',
                component: () => import('@/views/OffersAll.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.all'),
                    heading: i18n.t('enums.offers_heading.all'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('offers')
                }
            },
            {
                path: 'single-company',
                name: 'OffersSingleCompany',
                component: () => import('@/views/OffersSingleCompany.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.single_company'),
                    heading: i18n.t('enums.offers_heading.single_company'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('enums.offers_tabs.single_company')
                }
            },
            {
                path: 'eis-seis',
                name: 'OffersEisSeis',
                component: () => import('@/views/OffersEisSeis.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.eis_seis'),
                    heading: i18n.t('enums.offers_heading.eis_seis'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('enums.offers_tabs.eis_seis')
                }
            },
            {
                path: 'vct',
                name: 'OffersVct',
                component: () => import('@/views/OffersVct.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.vct'),
                    heading: i18n.t('enums.offers_heading.vct'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('enums.offers_tabs.vct')
                }
            },
            {
                path: 'iht',
                name: 'OffersIht',
                component: () => import('@/views/OffersIht.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.iht'),
                    heading: i18n.t('enums.offers_heading.iht'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('enums.offers_tabs.iht')
                }
            },
            {
                path: 'pmi',
                name: 'OffersPmi',
                component: () => import('@/views/OffersPmi.vue'),
                meta: {
                    title: i18n.t('investment_offers') + ' - ' + i18n.t('enums.offers_tabs.pmi'),
                    heading: i18n.t('enums.offers_heading.pmi'),
                    overline: i18n.t('investments'),
                    breadcrumb_label: i18n.t('enums.offers_tabs.pmi')
                }
            }
        ]
    },
    {
        path: '/offer',
        name: 'Offer',
        props: true,
        component: () => import('@/views/offer/Index.vue'),
        meta: {
            title: i18n.t('investment_offer'),
            heading: i18n.t('offer'),
            breadcrumbs: [
                {
                    heading: i18n.t('investment_offers'),
                    to: { name: 'Offers' }
                }
            ]
        }
    }
];
